module.exports = __webpack_public_path__ + "static/media/font-logo.ed255132.svg";